import { PageDefaultContainer, PageDefaultContainerProps, useFeedback } from "@sis/react-library"
import { Fragment, PropsWithChildren, useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { resetErrors } from "../../redux/common/commonActions";
import { CommonBaseState } from "../../interfaces/redux/common";
import { RppTitle } from "./RppTitle";
import { commonState } from "../../redux/common/commonSlice";
import { rdsState } from "../../redux/rds/rdsSlice";
import { scheduleState } from "../../redux/schedule/scheduleSlice";
import { winState } from "../../redux/win/winSlice";
import { derivState } from "../../redux/deriv/derivSlice";
import { trackState } from "../../redux/track/trackSlice";

export const PageContainer = ({
    children, heading, ...props
}: PropsWithChildren<PageDefaultContainerProps>) => {

    const { showError } = useFeedback();
    const dispatch = useAppDispatch();

    const states: CommonBaseState[] = [
        useAppSelector(commonState),
        useAppSelector(rdsState),
        useAppSelector(scheduleState),
        useAppSelector(winState),
        useAppSelector(derivState),
        useAppSelector(trackState)
    ]

    const checkStateForError = (state: CommonBaseState) => {
        if (state && state.error && state.errorMessage) {
            const messageSplit = state.errorMessage.split("\r\n"); 
            showError(<>
                {messageSplit.map((m, i) => (
                    <Fragment key={`${i}${m}`}>{m}{i === messageSplit.length - 1 ? <></> : <br />}</Fragment>
                ))}
            </>)
            dispatch(resetErrors());
        }
    }

    useEffect(() => {
        states?.forEach((state) => {
            if (state) { checkStateForError(state); }
        })
        // We want only the conditions below
        // eslint-disable-next-line
    }, [states.map(s => s.error)])    

    return (
        <PageDefaultContainer
            heading={heading}
            {...props}
        >
            <RppTitle title={heading} />
            {children}
        </PageDefaultContainer >
    )
}